import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("body-no-scroll");
    } else {
      document.body.classList.remove("body-no-scroll");
    }
    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, [isOpen]);

  const handleClose = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen((prev) => !prev);

  return (
    <>
      <nav className="navbar">
        <NavLink to="/home" className="navbar-logo" onClick={handleClose}>
  <img
    src="/images/logo.png"
    alt="Zzayraat Logo"
    className="logo-img"
  />
</NavLink>
        <button
          className={`hamburger${isOpen ? " open" : ""}`}
          aria-label="Toggle navigation"
          onClick={toggleMenu}
          type="button"
        >
          <span />
          <span />
          <span />
        </button>

        <ul className="nav-links desktop-nav">
          <li className="nav-link">
            <NavLink to="/" end>
              Home
            </NavLink>
          </li>
          <li className="nav-link">
            <NavLink to="/our-story">Our Story</NavLink>
          </li>
          <li className="nav-link">
            <NavLink to="/our-services">Our Services</NavLink>
          </li>
          <li className="nav-link">
            <NavLink to="/lets-connect">Let's Connect</NavLink>
          </li>
          {/* <li className="nav-link">
            <NavLink to="/zzayraat-connect">Zzayraat Connect</NavLink>
          </li> */}
        </ul>
      </nav>

      {isOpen && <div className="nav-overlay" onClick={handleClose} />}

      {isOpen && (
        <ul className="nav-links-mobile" role="menu" aria-label="Mobile navigation">
          <li className="nav-link" role="none">
            <NavLink to="/" end onClick={handleClose} role="menuitem" tabIndex={0}>
              Home
            </NavLink>
          </li>
          <li className="nav-link" role="none">
            <NavLink to="/our-story" onClick={handleClose} role="menuitem" tabIndex={0}>
              Our Story
            </NavLink>
          </li>
          <li className="nav-link" role="none">
            <NavLink to="/our-services" onClick={handleClose} role="menuitem" tabIndex={0}>
              Our Services
            </NavLink>
          </li>
          <li className="nav-link" role="none">
            <NavLink to="/lets-connect" onClick={handleClose} role="menuitem" tabIndex={0}>
              Let's Connect
            </NavLink>
          </li>
          {/* <li className="nav-link" role="none">
            <NavLink to="/zzayraat-connect" onClick={handleClose} role="menuitem" tabIndex={0}>
              Zzayraat Connect
            </NavLink>
          </li> */}
        </ul>
      )}
    </>
  );
};

export default Navbar;
